<template>
  <section>
    <aside @click.self.stop="toggleSidebar">
      <div class="sidebar hide" v-if="sidebarVisible">
        <button class="close" type="button" @click.prevent.stop="toggleSidebar"></button>
        <nav>
          <button id="new-product" class="new-product" type="button" @click.prevent.stop="handleNewProductPopupClick" alt="신제품 소개">
            <img :src="require('@/assets/2025/images/01_menu01.png')" loading="lazy" />
          </button>
          <button id="video" class="video" type="button" @click.prevent.stop="handleVideoClick" alt="캠페인 영상">
            <img :src="require('@/assets/2025/images/01_menu02.png')" loading="lazy" />
          </button>
          <!-- <button v-if="!game2Visible" id="game-menu" class="game-menu" type="button" @click.prevent.stop="handleGameClick" alt="게임-청춘응원편">
            <img :src="require('@/assets/2025/images/01_menu05.png')" loading="lazy" />
          </button>
          <button v-else id="game-menu" class="game-menu" type="button" @click.prevent.stop="handleGameClick" alt="게임-고민해결편">
            <img :src="require('@/assets/2025/images/01_menu03.png')" loading="lazy" />
          </button> -->
          <button id="game-menu" class="game-menu" type="button" @click.prevent.stop="handleGameClick" alt="게임">
            <img :src="require('@/assets/2025/images/01_menu03_final.png')" loading="lazy" />
          </button>
          <button id="collabo" class="collabo" type="button" @click.prevent.stop="handleCollaboManseon" alt="이벤트">
            <img :src="require('@/assets/2025/images/01_menu04.png')" loading="lazy" />
          </button>
        </nav>
      </div>
    </aside>

    <div class="main-contents" @mousedown="handleMouseDown" @mouseup="handleMouseup" @touchstart="handleTouchStart" @touchend="handleTouchEnd">
      <button id="sidebar-menu" class="menu" type="button" @click.prevent.stop="toggleSidebar"></button>
      <slot name="contents" />
    </div>
    <footer>
      <a id="instagram-link" href="https://www.instagram.com/jimbeam_kr/" target="blank">
        <img :src="require('@/assets/2025/images/01_sns_insta.png')" />
      </a>
      <div class="border"></div>
      <a id="youtube-link" href="https://www.youtube.com/@JimbeamHighball" target="_blank">
        <img :src="require('@/assets/2025/images/01_sns_youtube.png')" />
      </a>
    </footer>
  </section>
</template>

<script setup>
import { nextTick, ref, defineEmits /*, computed */ } from 'vue'
const sidebarVisible = ref(false)

// const game2 = {
//   url: 'https://simulator-2.vercel.app/',
//   startDate: '2025-06-23T00:00:00'
// }

// const game2Visible = computed(() => {
//   const today = new Date()
//   const startDate = new Date(game2.startDate)
//   return today >= startDate
// })

const toggleSidebar = () => {
  if (sidebarVisible.value) {
    const sidebar = document.querySelector('section .sidebar')
    if (sidebar) {
      sidebar.classList.toggle('hide')
    }
    setTimeout(() => {
      sidebarVisible.value = false
      document.body.style.overflowY = 'auto'
      sidebar.style.top = '0px'
    }, 250) // Delay to allow sidebar animation to complete
  } else {
    emit('updateGuideVisible', false)
    sidebarVisible.value = true
    document.body.style.overflowY = 'hidden'
    nextTick(() => {
      const sidebar = document.querySelector('section .sidebar')
      if (window.innerWidth < 640) {
        sidebar.style.setProperty('top', '0px', 'important')
      } else {
        sidebar.style.setProperty('top', window.scrollY + 'px', 'important')
      }
      if (sidebar) {
        sidebar.classList.toggle('hide')
      }
    })
  }
}
const emit = defineEmits(['updatePage', 'updateGuideVisible'])
const handleVideoClick = () => {
  toggleSidebar()
  emit('updatePage', 'videoList')
}

const savedPosition = ref({
  x: 0,
  y: 0
})

const handleMouseDown = event => {
  savedPosition.value.x = event.x
  savedPosition.value.y = event.y
}

const handleMouseup = event => {
  if (Math.abs(event.x - savedPosition.value.x) > 50 && event.x < savedPosition.value.x && Math.abs(event.y - savedPosition.value.y) < 50) {
    toggleSidebar()
  }
  savedPosition.value.x = 0
  savedPosition.value.y = 0
  if (event.target.closest('.slide-guide')) {
    emit('updateGuideVisible', false)
  }
}

const handleTouchStart = event => {
  if (event.touches.length > 1) {
    return
  }
  savedPosition.value.x = event.touches[0].clientX
  savedPosition.value.y = event.touches[0].clientY
}

const handleTouchEnd = event => {
  if (event.touches.length > 1) {
    return
  }
  const touchEndX = event.changedTouches[0].clientX
  const touchEndY = event.changedTouches[0].clientY
  if (Math.abs(touchEndX - savedPosition.value.x) > 50 && touchEndX < savedPosition.value.x && Math.abs(touchEndY - savedPosition.value.y) < 50) {
    toggleSidebar()
  }
  savedPosition.value.x = 0
  savedPosition.value.y = 0
  if (event.target.closest('.slide-guide')) {
    emit('updateGuideVisible', false)
  }
}

const handleNewProductPopupClick = () => {
  toggleSidebar()
  emit('updatePage', 'new-product')
}
const handleGameClick = () => {
  toggleSidebar()
  emit('updatePage', 'game')
}

const handleCollaboManseon = () => {
  toggleSidebar()
  emit('updatePage', 'collabo-manseon')
}
</script>
<style scoped>
section {
  background-color: #000;
  width: var(--contents-width);
  max-width: var(--max-contents-width);
  min-height: 100vh;
  min-height: 100svh;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 0 auto;
  justify-content: space-between;
}
section * {
  max-width: 100%;
  font-family: 'NanumSquare', sans-serif;
  line-height: 1.5;
}
section aside {
  background-color: rgba(0, 0, 0, 0);
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 0;
}
section aside:has(.sidebar) {
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 6;
}
section .sidebar {
  position: fixed;
  width: 73%;
  height: 100%;
  background-color: #fdd017;
  color: #000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  padding-top: calc(100vh * 0.1);
  padding-top: calc(100svh * 0.1);
  gap: 0.5rem;
  top: 0;
  right: 0;
  z-index: 6;
  margin-right: -1px;
  background-image: url('@/assets/2025/images/01_menu_img.png');
  background-position: right bottom;
  background-size: 60% auto;
  background-repeat: no-repeat;
  max-height: 100vh;
  max-height: 100svh;
}
section .sidebar nav {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0 2.5rem;
}

section .sidebar nav button {
  width: 100%;
  height: 4rem;
  font-size: 1.1rem;
  color: #000;
  font-weight: bold;
  background-color: transparent;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #000;
  z-index: 7;
}

section .sidebar nav button:hover {
  transform: scale(1.02);
}
section .sidebar:not(.hide) {
  right: 0;
  top: 0 !important;
  animation: sidebarIn 0.25s ease-in;
}
section .sidebar:not(.hide) nav button {
  animation: fadeIn 0.15s ease-in;
}
section .sidebar.hide {
  right: -100%;
  animation: sidebarOut 0.25s ease-in;
}
section .main-contents + .sidebar:not(.hide) button.menu {
  z-index: 6;
}
section .main-contents + .sidebar button.menu {
  z-index: 5;
}
section .sidebar button.close {
  position: absolute;
  border: none;
  color: transparent;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  -webkit-appearance: none;
  margin: 0;
  padding: 0;
  overflow: visible;
  line-height: normal;
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  right: 3.5%;
  top: 2.5%;
  font-size: 2.5rem;
  width: 2.5rem;
  height: 2.5rem;
  padding: 1.5rem;
  background-size: 1.7rem auto;
  background-image: url('@/assets/2025/images/01_btn_X.png');
  background-repeat: no-repeat;
}

section .main-contents button.menu {
  position: fixed;
  color: #fff;
  right: 3.5%;
  top: 2.5%;
  font-size: 2.5rem;
  width: 2.5rem;
  height: 2.5rem;
  padding: 1.5rem;
  background-image: url('@/assets/2025/images/01_btn_menu.png');
  background-repeat: no-repeat;
  background-size: 1.7rem auto;
  z-index: 5;
}

section .main-contents {
  width: var(--contents-width);
  max-width: var(--max-contents-width);
  height: var(--image-min-height);
  line-height: 0;
  position: relative;
  background-color: #000;
}

section .main-contents img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: top;
}
section .main-contents button {
  position: absolute;
  border: none;
  color: transparent;
  width: 2.5rem;
  height: 2.5rem;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  background-color: transparent;
  -webkit-appearance: none;
  margin: 0;
  padding: 0;
  overflow: visible;
  line-height: normal;
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
}
section .main-contents button::-moz-focus-inner {
  border: 0;
  padding: 0;
}
section .main-contents .video {
  top: 28%;
  left: 37%;
}
section .main-contents .video img {
  object-fit: contain;
  height: 1.3rem;
  aspect-ratio: 53 / 55;
}

section .main-contents .game-menu {
  top: 45%;
  left: 67%;
}
section .main-contents .game-menu img {
  object-fit: contain;
  height: 1.37rem;
  aspect-ratio: 31 / 27;
}
section .main-contents .new-product {
  top: 82%;
  left: 81%;
}

section .main-contents .new-product img {
  object-fit: contain;
  height: 1.3rem;
  aspect-ratio: 53 / 57;
}

section nav button > img {
  max-width: 100%;
  height: 1.3rem;
}

section footer {
  width: 100%;
  height: var(--footer-height);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: auto;
  background: #000;
}
section footer a:has(img) {
  display: inline-flex;
  justify-content: center;
  margin: 0 0.8rem;
}
section footer .border {
  width: 1px;
  height: calc(var(--footer-height) / 3);
  background-color: #616161;
  margin: 0 0.4rem;
}
section footer img {
  width: auto;
  max-height: 1.8rem;
}

section > p {
  text-align: center;
  margin-bottom: 6vh;
  font-size: 1rem;
}
section .logo {
  margin: 18vh auto 6vh auto;
  width: 30vw;
}
section .enter {
  /* background: none; */
  border: none;
  width: 100%;
  height: 3rem;
  border-radius: 1.5rem;
  font-size: 1.1rem;
}
section div.select {
  display: flex;
  justify-content: center;
  width: 100%;
  gap: 5vw;
  margin-bottom: 3vh;
}
section div.select label {
  width: 100%;
  height: 2.5rem;
}
section div.select select {
  width: 100%;
  border-radius: 1.25rem;
  color: #ffffff;
  font-size: 1.1rem;
  height: 100%;
  text-align: center;
  background-color: #55504d;
}
.popup-image {
  width: var(--contents-width);
  max-width: var(--max-contents-width);
  min-height: 100vh;
  min-height: 100svh;
  object-fit: cover;
  object-position: top center;
  aspect-ratio: 8 / 15;
}
@keyframes sidebarIn {
  from {
    right: -100%;
    opacity: 0;
  }
  to {
    right: 0;
    opacity: 1;
  }
}

@keyframes sidebarOut {
  from {
    right: 0;
    opacity: 1;
  }
  to {
    right: -100%;
    opacity: 0;
  }
}

@media (min-width: 640px) {
  section {
    width: auto;
    max-width: var(--desktop-contents-width);
    min-height: var(--desktop-contents-height);
  }
  section .main-contents {
    width: auto;
    max-width: var(--desktop-contents-width);
    height: var(--image-min-height);
  }
  section .main-contents img {
    object-fit: cover;
    width: auto;
    height: 100%;
  }
  section footer a:has(img) {
    max-width: calc(50% - 1rem);
    margin: auto;
  }
  section footer .border {
    margin: 0 1rem;
  }
  section .main-contents button.menu {
    position: absolute;
  }
  .popup-image {
    width: auto;
    max-width: min(var(--desktop-contents-width), 100%);
    min-height: max(var(--desktop-contents-height), 100vh, 100svh);
  }

  section:has(.sidebar) {
    position: relative;
  }

  section .sidebar {
    position: absolute;
    margin-right: -1px;
  }

  section .sidebar.hide {
    margin-right: 0;
  }
  section .sidebar.hide * {
    opacity: 0;
  }

  section .sidebar button.close {
    right: 5%;
    top: 2.5%;
  }
  section .sidebar nav {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
  }
  section .sidebar nav button img {
    user-drag: none;
    -webkit-user-drag: none;
    -moz-user-drag: none;
  }
  section .sidebar:not(.hide) {
    top: 0 !important;
  }
}
</style>
